// slider
document.addEventListener('DOMContentLoaded', () => {
  const pickupSplide = new Splide('.pickup_slide', {
    type: 'slide',
    perPage: 2,
    perMove: 1,
    arrows: true,
    pagination: true,
    focus: 'center',
    breakpoints: {
      840: {
        perPage: 1,
        fixedWidth: '78.66666666666666vw',
      }
    }
  });

  pickupSplide.on('mounted', () => {
    const pagination = document.querySelector('.pickup_slide .splide__pagination');
    const arrows = document.querySelector('.pickup_slide .splide__arrows');

    if (pagination && arrows) {
      const footer = document.createElement('div');
      footer.classList.add('splide__footer');
      pagination.parentNode.insertBefore(footer, pagination);
      footer.appendChild(pagination);
      footer.appendChild(arrows);
    }
  });

  pickupSplide.mount();
});
